import React from "react";
import CountUp from 'react-countup'
import VisibilitySensor from 'react-visibility-sensor'

export function WithoutBackHairDivider() {
  return (
    <section className="divider-section w-100 py-4 milan-bg-navy">
      <VisibilitySensor partialVisibility offset={{ bottom: 50 }}>
        {({ isVisible }) => (
          <div className="container">
            <div className="row justify-content-center milan-text-white text-center pt-1">
              <div className="col-12">
              <h3 className="subpointlg mb-0">
                 <strong><span className="milan-text-secondary width-fluid-0">{isVisible ? <CountUp end={93} duration={2} /> : 0}</span></strong><span className="milan-text-secondary">%</span> of Women Prefer a <br className="d-block d-xl-none"/>Man Without Back Hair
                </h3>
              </div>
            </div>
          </div>
        )}
      </VisibilitySensor>
    </section>
  );
}
export default WithoutBackHairDivider
